var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticStyle:{"background":"#E5E6EA","height":"100vh","overflow":"auto"}},[_c('SimpleHeader',{attrs:{"info":_vm.info}}),_c('Cart',{attrs:{"mode":'cart'}}),_c('SimpleFooter',{attrs:{"info":_vm.info}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }